import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PERMISSION_LIST } from 'common/constants/permissions';

export default () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const permission = [
        PERMISSION_LIST.GENERAL_INFORMATION_PERMISSION,
        PERMISSION_LIST.ROLES_PERMISSION,
        PERMISSION_LIST.USERS_PERMISSION,
    ];

    const options = [
        {
            label: t('Supplier', { count: 2 }),
            permission: permission,
            selected: ['/suppliers'].includes(pathname),
            to: '/suppliers',
        },
    ];

    return options;
};
